/* Material UI ======================================================================================== */
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wwwDateButtonGroup: {
      marginTop: theme.spacing(1),
    },
  }),
)
